import { createContext } from "react";

const WithdrawalCompanyScreen = createContext<any>(null);

export default WithdrawalCompanyScreen;
